import { ReactNode } from 'react'

import { Alert } from '@matillion/component-library'

import classes from './Footer.module.scss'

interface FooterProps {
  children: ReactNode
  warningText?: string
}

export const Footer = ({ children, warningText }: FooterProps) => (
  <div className={classes.Footer}>
    <hr className={classes.Footer__Divider} />
    {warningText && (
      <Alert
        className={classes.Footer__Warning}
        message={warningText}
        type="warning"
      />
    )}
    <div className={classes.Footer__Buttons}>{children}</div>
  </div>
)
